import React from 'react'
import Carousel from './Carousel'
import Hoodies from './Hoodies'
import JacketEdition from './JacketEdition'
import Slide from './Slide'
import Marqeen from './Marqeen'
import SocialSection from './SocialSection'
import Stats from './Stats'
import BioSurgeFAQ from './BioSurgeFAQ'
import Ingredients from './Ingredients'
import Testimonials from './Testimonials'
import FinalCTA from './FinalCTA'
// import Jackets from './Jackets'



function Home() {
  return (
   <>
   <Carousel/>
   <Slide/>
   <Hoodies/>
   <Marqeen/>
 <JacketEdition/>
 <SocialSection/>
 <Stats/>
 <Testimonials/>
 <BioSurgeFAQ/>
  <Ingredients/>
  <FinalCTA/>
 {/* <Jackets/> */}
   </>
  )
}

export default Home